module.exports = __webpack_public_path__ + "static/media/travels.f102e646.svg";